enum SeoDynamicSectionType{
  Section = 'section',
  Item = 'item'
}

export default SeoDynamicSectionType
